var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{attrs:{"list":_vm.list,"draggable":_vm.draggable}},[_c('transition-group',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }